







import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { HtmlCSS } from "@/services/posts/postTypes/html";

@Component
export default class HtmlStyle extends Vue {
    @Prop() private itemStyle!: Style;

    get model(): HtmlCSS {
        return this.itemStyle.css
            ? (this.itemStyle.css as HtmlCSS)
            : ({} as HtmlCSS);
    }
}
